import React from "react";

import traverseChildren from "./traverseChildren";

export default function getContextNodesFromChildren(childrenList = []) {
  const childArray = React.Children.toArray(childrenList);
  const parentComponent = childArray.length === 1 ? childArray[0]._owner : null;
  const childrenNodes = parentComponent ? traverseChildren(parentComponent) : [];

  return childrenNodes.filter(
    (node) => node?.elementType?._context?.displayName?.endsWith("Context") ?? false
  );
}
